import Col from '.';
import ColDesignTool from "../../../../lib/builtin/components/Col/ColDesignTool";

/** @type {UICore.ComponentMeta} */
const ColComponentMeta = {
  id: 'w-col',
  name: '某一列',
  component: Col,
  category: '布局',
  visible: false,
  slots: [{
    id: 'default',
    containerRef: 'container'
  }],
  designerFlags: {
    allowAdjustWidth: false,
    // Row 的 designTool 会接管
    allowAdjustHeight: false
  },
  designTool: ColDesignTool,
  getActions(ctx) {
    var _layout$props;
    const {
      layout,
      updateCompProp
    } = ctx;
    const useWidth = !!((_layout$props = layout.props) !== null && _layout$props !== void 0 && _layout$props.width);
    return [{
      title: `${useWidth ? '自适应宽度' : '定宽'}`,
      place: ['actionBar', 'propPanel', 'contextMenu'],
      icon: 'fa fa-random',
      async execute() {
        if (useWidth) {
          await updateCompProp('width', undefined);
        } else {
          await updateCompProp('width', '200px');
        }
      }
    }];
  },
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'justifyContent',
      type: 'string',
      title: '垂直对齐',
      enum: [{
        label: '顶部对齐',
        value: 'flex-start'
      }, {
        label: '居中对齐',
        value: 'center'
      }, {
        label: '底部对齐',
        value: 'flex-end'
      }]
    }, {
      id: 'alignItems',
      type: 'string',
      title: '水平对齐',
      default: 'stretch',
      enum: [{
        label: '拉伸',
        value: 'stretch'
      }, {
        label: '左对齐',
        value: 'flex-start'
      }, {
        label: '居中对齐',
        value: 'center'
      }, {
        label: '右对齐',
        value: 'flex-end'
      }]
    }, {
      id: 'width',
      type: 'string',
      title: '固定宽度',
      ui: {
        settings: {
          placeholder: '如无必要勿使用。例：200px'
        }
      },
      condition: '!!props.width'
    }, {
      id: 'weight',
      type: 'number',
      default: 1,
      condition: '!props.width'
    }]
  }
};
export default ColComponentMeta;